import textBodyMRegular from '@fukku/styles/texts/textBodyMRegular.module.css'
import { cx } from 'utils/cx'
import styles from './ButtonBase.module.css'

export type TextStyles = 'uppercaseS' | 'default'

export function ButtonBase(
	props: React.ComponentProps<'button'> & {
		readonly fullWidth?: boolean
	}
): React.ReactNode {
	const { children, type, onClick, disabled, className, fullWidth, ...rest } =
		props

	const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (disabled) {
			event.preventDefault()
			event.stopPropagation()
		} else {
			onClick?.(event)
		}
	}

	return (
		<button
			className={cx(
				styles.button,
				textBodyMRegular.className,
				fullWidth && styles.fullWidth,
				className
			)}
			{...rest}
			type={type ?? 'button'}
			onClick={handleOnClick}
			aria-disabled={disabled}
		>
			{children}
		</button>
	)
}
